<template>
  <div class="gateWay">
    <!-- 导航 -->
    <myheader v-if="show === 0" class="header"></myheader>
    <myheader_white v-if="show === 1" class="header_white"></myheader_white>

    <!-- 整页山景底图：绝对定位挂在 .gateWay 上，z-index -2（低于各页 banner 图的 -1），
         底边贴页面/视口底，页脚与内容都盖在它上面 -->
    <img
      v-if="showMainBg"
      class="page-bg"
      src="@/assets/text/bg_main.png"
      alt=""
    />

    <div class="main">
      <router-view :key="route.path"></router-view>
    </div>

    <!-- footer -->
    <myfooter class="footer"></myfooter>
  </div>
</template>

<script setup>
import myheader from "./components/myheader.vue";
import myfooter from "./components/myfooter.vue";
// import myfooterWhite from "./components/myfooter_white.vue"
import myheader_white from "./components/myheader_white.vue";
import { useRoute } from "vue-router";
import { watch, ref, computed } from "vue";
const route = useRoute();
const show = ref(0);
// 需要整页山景底图的页面（集团简介 chooseKey 缺省即 1、板块业务）。
// 页面里不再各放一张绝对定位的底图：挂在本层才盖得住"窗口比页面高"时的余量，
// 且 z-index -2 保证永远在各页 banner 图（z-index -1）之下。
const showMainBg = computed(
  () =>
    (route.path === "/groupOverview" &&
      (!route.query.chooseKey || route.query.chooseKey === "1")) ||
    route.path === "/blockBusiness"
);
watch(
  () => route,
  (initInfo, prevInitInfo) => {
    let path = initInfo.fullPath;
    if (path === "/index") {
      show.value = 0;
    } else {
      show.value = 1;
    }
  },
  { deep: true, immediate: true }
);
</script>

<style scoped lang="less">
.gateWay {
  width: var(--screen-width);
  min-height: var(--screen-height);
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.header {
  width: 83%;
  height: var(--layout-header-height);
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.header_white {
  width: 100%;
  height: 116px;
  position: relative;
  top: 0px;
}
.main {
  // 内容不足一屏时把页脚顶到视口底部；原来的 min-height 里写死了 600px 的页脚高度
  flex: 1 0 auto;
  box-sizing: border-box;
  overflow: hidden;
}
.page-bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: -2;
  pointer-events: none;
}
</style>
